
export default (jobsDocs) => {
  return jobsDocs?.sort((a, b) => {
    return `${a.get("schedule.date")} ${a.get("schedule.start") || "23:59"}`.localeCompare(
      `${b.get("schedule.date")} ${b.get("schedule.start") || "23:59"}`
    );
  })
}